import { api } from './client';
import { ADMIN_LOOKUP_SIZE, ADMIN_PAGE_SIZE } from './adminTypes';
export { fetchAdminMe } from './admin';
export async function fetchAdminRestaurantsPage(page = 0, size = ADMIN_PAGE_SIZE) {
    const res = await api.get('/v1/admin/restaurants', {
        params: { page, size },
    });
    return res.data;
}
export async function fetchAdminRestaurantsLookup() {
    const res = await fetchAdminRestaurantsPage(0, ADMIN_LOOKUP_SIZE);
    return res.content;
}
export async function fetchAdminRestaurant(id) {
    const res = await api.get(`/v1/admin/restaurants/${id}`);
    return res.data;
}
export async function createAdminRestaurant(body) {
    const res = await api.post('/v1/admin/restaurants', body);
    return res.data;
}
export async function updateAdminRestaurant(id, body) {
    const res = await api.put(`/v1/admin/restaurants/${id}`, body);
    return res.data;
}
export async function deleteAdminRestaurant(id) {
    await api.delete(`/v1/admin/restaurants/${id}`);
}
export async function updateAdminRestaurantDisabledProducts(id, productIds) {
    const res = await api.put(`/v1/admin/restaurants/${id}/disabled-products`, { productIds });
    return res.data;
}
export async function fetchAdminRestaurantEmails(restaurantId) {
    const res = await api.get(`/v1/admin/restaurants/${restaurantId}/notification-emails`);
    return res.data;
}
export async function addAdminRestaurantEmail(restaurantId, email) {
    const res = await api.post(`/v1/admin/restaurants/${restaurantId}/notification-emails`, { email });
    return res.data;
}
export async function deleteAdminRestaurantEmail(restaurantId, email) {
    await api.delete(`/v1/admin/restaurants/${restaurantId}/notification-emails`, { params: { email } });
}
export async function fetchAdminRestaurantTelegramChats(restaurantId) {
    const res = await api.get(`/v1/admin/restaurants/${restaurantId}/telegram-chats`);
    return res.data;
}
export async function addAdminRestaurantTelegramChat(restaurantId, chatId) {
    const res = await api.post(`/v1/admin/restaurants/${restaurantId}/telegram-chats`, { chatId });
    return res.data;
}
export async function deleteAdminRestaurantTelegramChat(restaurantId, chatId) {
    await api.delete(`/v1/admin/restaurants/${restaurantId}/telegram-chats`, { params: { chatId } });
}
export async function fetchAdminUsersPage(page = 0, size = ADMIN_PAGE_SIZE, search) {
    const res = await api.get('/v1/admin/users', {
        params: { page, size, search },
    });
    return res.data;
}
export async function fetchAdminUser(id) {
    const res = await api.get(`/v1/admin/users/${id}`);
    return res.data;
}
export async function createAdminUser(body) {
    const res = await api.post('/v1/admin/users', body);
    return res.data;
}
export async function updateAdminUser(id, body) {
    const res = await api.put(`/v1/admin/users/${id}`, body);
    return res.data;
}
export async function deleteAdminUser(id) {
    await api.delete(`/v1/admin/users/${id}`);
}
export async function fetchAdminUserAddresses(id) {
    const res = await api.get(`/v1/admin/users/${id}/addresses`);
    return res.data;
}
export const ORDER_STATUSES = [
    'CREATED',
    'AWAITING_PAYMENT',
    'PREPARING',
    'READY_FOR_PICKUP',
    'ON_THE_WAY',
    'RECEIVED',
    'PREPAIR_TO_CANCELLED',
    'CANCELLED_WITH_REFUND',
    'CANCELLED_WITHOUT_REFUND',
];
export const ORDER_STATUS_LABELS = {
    CREATED: 'Создан',
    AWAITING_PAYMENT: 'Ожидает оплаты',
    PREPARING: 'Готовится',
    READY_FOR_PICKUP: 'Готов к выдаче',
    ON_THE_WAY: 'В пути',
    RECEIVED: 'Получен',
    PREPAIR_TO_CANCELLED: 'Подготовка к отмене',
    CANCELLED_WITH_REFUND: 'Отменён с возвратом',
    CANCELLED_WITHOUT_REFUND: 'Отменён без возврата',
};
export async function fetchAdminOrdersPage(page = 0, size = ADMIN_PAGE_SIZE, params = {}) {
    const res = await api.get('/v1/admin/orders', {
        params: { page, size, ...params },
    });
    return res.data;
}
export async function fetchAdminOrder(id) {
    const res = await api.get(`/v1/admin/orders/${id}`);
    return res.data;
}
export async function updateAdminOrderStatus(id, status) {
    const res = await api.patch(`/v1/admin/orders/${id}/status`, { status });
    return res.data;
}
export function nextAdminOrderStatus(order) {
    if (order.status === 'PREPARING' && order.deliveryType === 'PICKUP') {
        return { status: 'READY_FOR_PICKUP', label: 'Готов к выдаче' };
    }
    if (order.status === 'PREPARING' && order.deliveryType === 'COURIER') {
        return { status: 'ON_THE_WAY', label: 'В пути' };
    }
    if (order.status === 'READY_FOR_PICKUP' && order.deliveryType === 'PICKUP') {
        return { status: 'RECEIVED', label: 'Выдан' };
    }
    if (order.status === 'READY_FOR_PICKUP') {
        return { status: 'RECEIVED', label: 'Получен' };
    }
    if (order.status === 'ON_THE_WAY') {
        return { status: 'RECEIVED', label: 'Получен' };
    }
    return null;
}
export async function fetchAdminBonusAccounts(page = 0, size = ADMIN_PAGE_SIZE) {
    const res = await api.get('/v1/admin/bonus-accounts', {
        params: { page, size },
    });
    return res.data;
}
export async function fetchAdminBonusTransactions(page = 0, size = ADMIN_PAGE_SIZE) {
    const res = await api.get('/v1/admin/bonus-transactions', {
        params: { page, size },
    });
    return res.data;
}
export async function fetchAdminConfigs(page = 0, size = ADMIN_PAGE_SIZE) {
    const res = await api.get('/v1/admin/configs', { params: { page, size } });
    return res.data;
}
export async function updateAdminConfig(id, value) {
    const res = await api.put(`/v1/admin/configs/${id}`, { value });
    return res.data;
}
export async function fetchAdminMetrics(params) {
    const search = new URLSearchParams();
    search.set('from', params.from);
    search.set('to', params.to);
    search.set('interval', params.interval);
    (params.restaurantIds ?? []).forEach((id) => search.append('restaurantIds', String(id)));
    const res = await api.get(`/v1/admin/metrics/turnover?${search.toString()}`);
    return res.data;
}
export function canToggleAdminUser(me, user) {
    if (!me)
        return false;
    if (user.id === me.id || user.role === 'ROOT')
        return false;
    if (me.role === 'ROOT')
        return user.role === 'USER' || user.role === 'ADMIN';
    if (me.role === 'ADMIN')
        return user.role === 'USER';
    return false;
}
export function canDeleteAdminUser(me, user) {
    return canToggleAdminUser(me, user);
}
